"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStateMachine = void 0;
var _react = require("react");
var _javascriptStateMachine = _interopRequireDefault(require("javascript-state-machine"));
var _reactUse = require("react-use");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// eslint-disable-next-line  @typescript-eslint/no-explicit-any

// eslint-disable-next-line  @typescript-eslint/no-explicit-any

// eslint-disable-next-line  @typescript-eslint/no-explicit-any

var createMachine = function createMachine(_ref) {
  var stage = _ref.stage,
    transitions = _ref.transitions,
    methods = _ref.methods;
  return new _javascriptStateMachine.default({
    init: stage,
    transitions: transitions,
    methods: methods
  });
};
var useStateMachine = function useStateMachine(_ref2) {
  var initialStage = _ref2.initialStage,
    transitions = _ref2.transitions,
    methods = _ref2.methods,
    _ref2$context = _ref2.context,
    context = _ref2$context === void 0 ? {} : _ref2$context;
  var _useState = (0, _react.useState)(initialStage),
    _useState2 = _slicedToArray(_useState, 2),
    stage = _useState2[0],
    setStage = _useState2[1];
  var previousStage = (0, _reactUse.usePreviousDistinct)(stage);
  var transition = function transition(action) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var machine = createMachine({
      stage: stage,
      transitions: transitions,
      methods: methods
    });
    machine[action](context, payload);
    setStage(machine.state);
  };
  return {
    transition: transition,
    stage: stage,
    previousStage: previousStage
  };
};
exports.useStateMachine = useStateMachine;